var _defs, _line, _line2, _line3, _rect, _rect2, _rect3, _circle, _circle2, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmartsen4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "nodeGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#60A5FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2563EB"
  })))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 64,
    y1: 40,
    x2: 32,
    y2: 72,
    stroke: "#93C5FD",
    strokeWidth: 3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 64,
    y1: 40,
    x2: 96,
    y2: 72,
    stroke: "#93C5FD",
    strokeWidth: 3
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 72,
    x2: 96,
    y2: 72,
    stroke: "#93C5FD",
    strokeWidth: 3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 24,
    width: 32,
    height: 24,
    rx: 6,
    fill: "url(#nodeGrad)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 64,
    width: 32,
    height: 24,
    rx: 6,
    fill: "url(#nodeGrad)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 64,
    width: 32,
    height: 24,
    rx: 6,
    fill: "url(#nodeGrad)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 36,
    r: 3,
    fill: "#FACC15"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 76,
    r: 3,
    fill: "#FACC15"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 76,
    r: 3,
    fill: "#FACC15"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartsen4);
export default __webpack_public_path__ + "static/media/smartsen_4.c03d78246b59b0ebda66a16f64ecb6e2.svg";
export { ForwardRef as ReactComponent };